export const BRADESCO = "bradesco";
export const BANCODOBRASIL = "bancodobrasil";
